import FilterAltIcon from "@mui/icons-material/FilterAlt";
import SearchIcon from "@mui/icons-material/Search";
import {
  Box,
  InputAdornment,
  InputBase,
  Table,
  TableContainer,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import CustomPagination from "./CustomPagination";
import FilledButton from "./FilledButton";
import TableHeader2 from "./TableHeader2";
// import UserManagementModal from "./UserManagementModal";
import AddIcon from "@mui/icons-material/Add";
import UserManagementTableBody from "./UserManagementTableBody";

const styles = {
  box1Style: {
    display: "flex",
    justifyContent: "space-between",
    p: 2,
    borderBottom: "1px solid #E4E4E4",
    alignItems: "center",
  },
  newCompanyButtonStyle: {
    textTransform: "capitalize",
    borderRadius: "20px",
    backgroundColor: "#00A398",
    mr: 2,
    "&:hover": {
      backgroundColor: "#00A398",
    },
  },
  iconStyle: { fontSize: "17px", marginRight: "3px" },
  searchIconStyle: {
    color: "#9F9F9F",
    ml: "3px",
    mr: "-3px",
    width: "20px",
    height: "20px",
  },
  inputStyle: {
    borderRadius: "20px",
    width: "55%",
    height: "32px",
    border: "1px solid #9F9F9F",
  },
  filterDownloadStyle: {
    color: "white",
    borderRadius: "50%",
    backgroundColor: "#0077B6",
    fontSize: "32px",
    padding: "5px",
    cursor: "pointer",
  },
};

const tableData = {
  columns: [
    "Name",
    "Employee ID",
    "Designation",
    "Email",
    "Phone",
    "Shift",
    "Role",
    "Activity",
    "",
  ],
  rows: [
    {
      id: 1,
      name: "UserName",
      employee: "XXXXXX",
      designation: "Designation",
      email: "name@example.domain",
      phone: "(000) 000 0000",
      shift: "A",
      role: "Admin",
      activity: "Signed In 18/11/2023 12:34:26",
    },
  ],
};

function UserManagement() {
  const [modalOpen, setModalOpen] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [userList, setUserList] = useState([]);
  const [search, setSearch] = useState("");
  const [filteredRows, setFilteredRows] = useState([]);

  const totalPages = Math.ceil(filteredRows?.length / itemsPerPage);

  const handleChangePage = (newPage) => {
    setCurrentPage(newPage);
  };

  const handleChangeItemsPerPage = (items) => {
    setItemsPerPage(items);
    setCurrentPage(1);
  };

  let currentData = filteredRows?.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  // Ensuring currentData always has 20 items
  const placeholderRow = {};
  while (currentData?.length < itemsPerPage) {
    currentData.push(placeholderRow);
  }

  //   const fetchUsersList = async () => {
  //     try {
  //       const response = await axios.get(
  //         `${BaseURL}/api/v1/users/${localStorage.getItem(
  //           "userid"
  //         )}/1/get-user-list`
  //       );
  //       setUserList(response.data.data);
  //     } catch (error) {
  //       console.log(error);
  //     }
  //   };

  //   useEffect(() => {
  //     fetchUsersList();
  //   }, []);

  useEffect(() => {
    setUserList(tableData.rows);
  }, []);

  const handleUploadClick = () => {
    setModalOpen(true);
  };

  const handleModalClose = () => {
    setModalOpen(false);
  };

  const handleSearch = (e) => {
    setSearch(e.target.value);
  };

  useEffect(() => {
    if (userList) {
      const filteredData = userList?.filter(
        (task) =>
          task?.firstName?.toLowerCase()?.includes(search?.toLowerCase()) ||
          task?.lastName?.toLowerCase()?.includes(search?.toLowerCase()) ||
          task?.description?.toLowerCase()?.includes(search?.toLowerCase()) ||
          task?.email?.toLowerCase()?.includes(search?.toLowerCase()) ||
          task?.status?.toLowerCase()?.includes(search?.toLowerCase())
      );
      setFilteredRows(filteredData);
      setCurrentPage(1);
    }
  }, [userList, search]);

  return (
    <>
      <Box sx={styles.box1Style}>
        <Typography sx={{ fontSize: "23px", fontWeight: "500" }}>
          User Management
        </Typography>
        <Box
          sx={{
            display: "flex",
            gap: "10px",
            alignItems: "center",
            justifyContent: "flex-end",
          }}
        >
          <FilledButton
            btnname={"Add New User"}
            icon={<AddIcon />}
            onClick={handleUploadClick}
          />
        </Box>
        {/* <UserManagementModal open={modalOpen} handleClose={handleModalClose} /> */}
      </Box>
      <Box>
        <TableContainer
          sx={{
            width: "100%",
            // maxHeight: "89.5vh",
            // overflowX: "auto",
          }}
        >
          <Table sx={{ minWidth: 650 }} aria-label="simple table" stickyHeader>
            <TableHeader2 tableData={tableData} />
            <UserManagementTableBody filledRows={currentData} />
          </Table>
        </TableContainer>
        <CustomPagination
          currentPage={currentPage}
          totalPages={totalPages}
          changePage={handleChangePage}
          changeItemsPerPage={handleChangeItemsPerPage}
          minRows={10}
        />
      </Box>
    </>
  );
}

export default UserManagement;
